$(function () {
    if ($('#wsp-hours-details-form').length > 0) {


        
        $.validator.methods.number = function (value, element) {
            return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:\.\d{3})+)?(?:,\d+)?$/.test(value);
        }
        $('button.draft').prop('disabled', true);

        function round(value) {
            var formattedValue = value.toLocaleString('en', {
                useGrouping: false,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            return Number(formattedValue)
        }



        /**/
        
        var formatter = new Intl.NumberFormat(numFormatString, { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false });
        var formatter2 = new Intl.NumberFormat(numFormatString, { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true });
        /**/
        // totals calculation
        function calcTotals() {
            var subtotal = 0.00;
            $('.details input.funding').each(function () {
                subtotal += parseFloat($(this).val().toString().replace(",", "."));
            });

            $('input.subtotal').val(formatter2.format(subtotal));
            $('input.admin').val(formatter2.format(round(subtotal * jsAdminPercent)));
            $('input.total').val(formatter2.format(subtotal + round(subtotal * jsAdminPercent)));

            if (subtotal && subtotal > 0) {
                $('button.draft').prop('disabled', false);
            }
        }

        function calcInput(self, obj) {
            var isfor = self.data('for');


            var val = self.val() == '' ? '0' : self.val().toString().replace(",", ".");
            var input = round(parseFloat(val)); //(val).toFixed(2);

            var max = parseFloat(self.data('max').toString().replace(",", "."));


            var funding = parseFloat(self.data('funding').toString().replace(",", "."));
            if (input > max) {
                self.addClass('error');
                self.parent().parent().find('span.field-validation-valid.' + isfor).html('<i class="fa fas fa-exclamation-triangle"></i>');
            } else {
                self.removeClass('error');
                self.parent().parent().find('span.field-validation-valid.' + isfor).html('');
            }

            // If the input couldn't be parsed (is NaN) we will just set it to zero.
            if (isNaN(input) || self.val() == '') {
                input = 0;
            } else {
                self.val(formatter.format(input));
            }

            obj.val = input;
            obj.funding = round(funding * input);
        }

        function calcRow(rowid) {
            //console.log(rowid);
            var row = $("div.details[data-row=" + rowid + "]");
            var pre = row.find("input[data-for=PreHoursText]");
            var school = row.find("input[data-for=SchoolHoursText]");
            var non = row.find("input[data-for=NonInfantPreHoursText]");
            var nonsch = row.find("input[data-for=NonSchoolageHoursText]");

            var hours = row.find("input[data-for=HoursText]");


            $(this).parent().find("span").tooltip('hide'); // hide tooltip if triggered from submit button

            var total = 0;
            var thours = 0;

            // Preschool
            var preObj = { funding: 0, val: 0 };
            calcInput(pre, preObj);
            if (!isNaN(preObj.funding)) {
                total += preObj.funding;
                thours += preObj.val;
            }

            // School age
            var schObj = { funding: 0, val: 0 };
            calcInput(school, schObj);
            if (!isNaN(schObj.funding)) {
                total += schObj.funding;
                thours += schObj.val;
            }

            // Non designated Inf-Pre
            var nonObj = { funding: 0, val: 0 };
            calcInput(non, nonObj);
            if (!isNaN(nonObj.funding)) {
                total += nonObj.funding;
                thours += nonObj.val;
            }
            // Non designated School
            var nonschObj = { funding: 0, val: 0 };
            calcInput(nonsch, nonschObj);
            if (!isNaN(nonschObj.funding)) {
                total += nonschObj.funding;
                thours += nonschObj.val;
            }

            hours.val(thours);
            // total hours    
            var hoursObj = { funding: 0, val: 0 };
            calcInput(hours, hoursObj);
            if (!isNaN(hoursObj.funding)) {
                total += hoursObj.funding;
            }

            //console.log(total);
           // console.log(row.find('input.funding').val(total));
            row.find('input.funding').val(total.toFixed(2).replace('.', decimalValue));

            calcTotals();

        }

        // max hours validation
        $('input.hours').on('blur', function () {
            var rowid = $(this).parents('.details').data('row');
            calcRow(rowid);
        });



        // submit modal
        $('.presubmit').on('click', function (e) {

            if (ishome == true) {
                var max = 0.0;
                var sum = 0.0;

                $("input.thours").each(function (e) {
                    sum += parseFloat($(this).val().toString().replace(",", "."));
                    var tmax = parseFloat($(this).data('max').toString().replace(",", "."));
                    if (tmax > max) {
                        max = tmax;
                    }
                });

                console.log(max);
                console.log(sum);
                if (sum > max) {
                    console.log("error !");
                    $(".homeerror").addClass('mt-3').removeClass('d-none');
                    return false;
                }
            } else {
                var isOver = false;
                $("input.hours").each(function (e) {
                    if (parseFloat($(this).val().toString().replace(",", ".")) > parseFloat($(this).data('max').toString().replace(",", "."))) {
                        isOver = true;
                        $(this).parent().find("span").tooltip('show');
                        $(this).trigger('focus');
                        return false;
                    }
                    else {
                        $(this).parent().find("span").tooltip('hide');
                    };
                });

                if (isOver) {
                    return false;
                }
            }

            if ($("#wsp-hours-details-form").valid()) {
                $("#approveModal").modal('show');
            }


            return false;
        });



        $("input.sa").on("keydown", function (e) {
            // allow function keys and decimal separators
            if (
                // backspace, delete, tab, escape, enter, comma and .
                $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 188, 190]) !== -1 ||
                // Ctrl/cmd+A, Ctrl/cmd+C, Ctrl/cmd+X
                ($.inArray(e.keyCode, [65, 67, 88]) !== -1 && (e.ctrlKey === true || e.metaKey === true)) ||
                // home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {

                /*
                // optional: replace commas with dots in real-time (for en-US locals)
                if (e.keyCode === 188) {
                    e.preventDefault();
                    $(this).val($(this).val() + ".");
                }

                // optional: replace decimal points (num pad) and dots with commas in real-time (for EU locals)
                if (e.keyCode === 110 || e.keyCode === 190) {
                    e.preventDefault();
                    $(this).val($(this).val() + ",");
                }
                */

                return;
            }
            // block any non-number
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });
        $("input.sa").on('click', function () {
            $(this)[0].setSelectionRange(0, this.value.length);
        });

        $("#Confirm").on('click', function (e) {
            if ($(this).attr("readonly") == "readonly") {
                e.preventDefault();
                return false;
            }
        });

        // trigger validation
        $('input.hours').blur();

        $('[data-toggle="tooltip"]').tooltip({
            placement: "top",
            container: "body",
            trigger: "manual",
            html: true
        });

        $("#AvailablePreSchoolFullTime, #AvailablePreSchoolPartTime, #AvailableAfterSchool").on('input', function () {
            var self = $(this);
            if (self.val().toString().length > 5) {
                self.val(self.val().toString().substring(0, 5));
            }
        });

    } // if ($('#wsp-hours-details-form').length > 0)
}); // $(function () {